import { environment } from 'src/environments/environment';
import {
  imageUploadFlagEvent,
  imageUploadSubject,
} from '../service/image-upload-event';

export const flashcardTinyMceOptionFront = {
  //  base_url: '/tinymce', // Root for resources
  //  suffix: '.min',        // Suffix to use when loading resources

  // Add wiris plugin
  //  external_plugins: {
  //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
  //  },

  base_url: 'https://www.perfectlearningapp.com/tinymce',
  content_style: 'body { font-size: 24px; }',

  // base_url: 'http://uat.perfectlearningapp.com/tinymce',

  // base_url: 'https://dev.perfectlearningapp.com/tinymce',
  // base_url: '/tinymce',
  suffix: '.min',
  height: 700, // Suffix to use when loading resources
  init_instance_callback: function (editor: {
    on: (arg0: string, arg1: (e: any) => void) => void;
  }) {
    editor.on('Dirty', function (e) {
      console.log('Editor is dirty!');
    });
  },
  image_dimensions: true,
  images_upload_handler: (
    blobInfo: any,
    success: any,
    failure: any,
    progress: any
  ) => {
    return new Promise((resolve, reject) => {
      let xhr: any, formData;

      imageUploadFlagEvent.next(true);

      xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.open('POST', environment.apiBaseUrl + 'api/UploadImageTextEditor');

      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${localStorage.getItem('userToken')}`
      );

      xhr.upload.onprogress = function (e: any) {
        success(Math.floor((e.loaded / e.total) * 100));
      };

      xhr.onload = function () {
        var json;

        if (xhr.status === 403) {
          // failure('HTTP Error: ' + xhr.status, { remove: true });
          reject('Not able to Upload File');
          imageUploadFlagEvent.next(false);
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          // failure('HTTP Error: ' + xhr.status);
          reject('Not able to Upload File');
          imageUploadFlagEvent.next(false);
          return;
        }

        json = JSON.parse(xhr.responseText);

        if (!json || typeof json.location != 'string') {
          // failure('Invalid JSON: ' + xhr.responseText);
          reject('Not able to Upload File');
          imageUploadFlagEvent.next(false);
          return;
        }

        resolve(environment.apiBaseUrl + json.location);
        imageUploadSubject.next({
          url: environment.apiBaseUrl + json.location,
          height: json.height,
          width: json.width,
        });
        imageUploadFlagEvent.next(false);
      };

      xhr.onerror = function () {
        reject('Not able to Upload File');
      };

      formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      formData.append('height', '507');
      formData.append('width', '760');

      xhr.send(formData);
    });
  },

  // Add wiris plugin
  //  init_instance_callback: function (editor: { on: (arg0: string, arg1: (e: any) => void) => void; }) {
  //   editor.on('keyup', function (e) {

  //     e.GetContent();

  //   });
  // editor.on('GetContent', function (e) {
  //   e.content;
  //   console.log(e.content,'content');

  // });
  // },
  //  external_plugins: {

  //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`,

  //  },

  extended_valid_elements: '*[.*]',

  menu: {
    file: { title: 'File', items: ' preview |deleteallconversations' },
    edit: {
      title: 'Edit',
      items: 'undo redo | paste pastetext | searchreplace',
    },
    view: {
      title: 'View',
      items:
        'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments',
    },
    insert: {
      title: 'Insert',
      items:
        'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime | eqneditor',
    },
    format: {
      title: 'Format',
      items:
        'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat',
    },
    tools: {
      title: 'Tools',
      items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount',
    },
    table: {
      title: 'Table',
      items:
        'inserttable | cell row column | advtablesort | tableprops deletetable',
    },
  },

  importcss_append: true,
  autosave_ask_before_unload: true,
  promotion: false,
  branding: false,
  elementpath: false,
  advlist_bullet_styles: 'default,circle,disc,square',
  htmlAllowedTags: ['.*'],
  htmlAllowedAttrs: ['.*'],
  plugins: [
    'eqneditor',
    'image',
    'media',
    'table',
    'Tools',
    'charmap',
    'code',
    'anchor',
    'link',
    'autosave',
    'directionality',
    'emoticons',
    'fullscreen',
    'importcss',
    'insertdatetime',
    'lists',
    'nonbreaking',
    'pagebreak',
    'preview',
    'quickbars',
    'save',
    'searchreplace',
    'wordcount',
    'visualblocks',
    'visualchars',
  ],
  toolbar:
    'eqneditor undo redo styleselect bold italic  alignleft aligncenter alignright alignjustify  outdent indent numlist bullist  preview searchreplace code anchor link restoredraft  charmap ltr rtl emoticons fullscreen  insertdatetime pagebreak quickimage save wordcount visualblocks visualchars tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
  eqneditor_server: 'fxtex.codecogs.com',
  eqneditor_licence: environment.codecogsLicenceKey || '',
  eqneditor_design: {
    colour: '#1a73e8',
  },
  //  tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry
  // table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol |
};

export const flashcardTinyMceOptionBack = {
  //  base_url: '/tinymce', // Root for resources
  //  suffix: '.min',        // Suffix to use when loading resources

  // Add wiris plugin
  //  external_plugins: {
  //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
  //  },

  base_url: 'https://www.perfectlearningapp.com/tinymce',
  content_style: 'body { font-size: 18px; }',

  // base_url: 'http://uat.perfectlearningapp.com/tinymce',

  // base_url: 'https://dev.perfectlearningapp.com/tinymce',
  // base_url: '/tinymce',
  suffix: '.min',
  height: 700, // Suffix to use when loading resources
  init_instance_callback: function (editor: {
    on: (arg0: string, arg1: (e: any) => void) => void;
  }) {
    editor.on('Dirty', function (e) {
      console.log('Editor is dirty!');
    });
  },
  image_dimensions: true,
  images_upload_handler: (
    blobInfo: any,
    success: any,
    failure: any,
    progress: any
  ) => {
    return new Promise((resolve, reject) => {
      let xhr: any, formData;

      imageUploadFlagEvent.next(true);

      xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.open('POST', environment.apiBaseUrl + 'api/UploadImageTextEditor');

      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${localStorage.getItem('userToken')}`
      );

      xhr.upload.onprogress = function (e: any) {
        success(Math.floor((e.loaded / e.total) * 100));
      };

      xhr.onload = function () {
        var json;

        if (xhr.status === 403) {
          // failure('HTTP Error: ' + xhr.status, { remove: true });
          reject('Not able to Upload File');
          imageUploadFlagEvent.next(false);
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          // failure('HTTP Error: ' + xhr.status);
          reject('Not able to Upload File');
          imageUploadFlagEvent.next(false);
          return;
        }

        json = JSON.parse(xhr.responseText);

        if (!json || typeof json.location != 'string') {
          // failure('Invalid JSON: ' + xhr.responseText);
          reject('Not able to Upload File');
          imageUploadFlagEvent.next(false);
          return;
        }

        resolve(environment.apiBaseUrl + json.location);
        imageUploadSubject.next({
          url: environment.apiBaseUrl + json.location,
          height: json.height,
          width: json.width,
        });
        imageUploadFlagEvent.next(false);
      };

      xhr.onerror = function () {
        reject('Not able to Upload File');
      };

      formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      formData.append('height', '507');
      formData.append('width', '760');

      xhr.send(formData);
    });
  },

  // Add wiris plugin
  //  init_instance_callback: function (editor: { on: (arg0: string, arg1: (e: any) => void) => void; }) {
  //   editor.on('keyup', function (e) {

  //     e.GetContent();

  //   });
  // editor.on('GetContent', function (e) {
  //   e.content;
  //   console.log(e.content,'content');

  // });
  // },
  //  external_plugins: {

  //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`,

  //  },

  extended_valid_elements: '*[.*]',

  menu: {
    file: { title: 'File', items: ' preview |deleteallconversations' },
    edit: {
      title: 'Edit',
      items: 'undo redo | paste pastetext | searchreplace',
    },
    view: {
      title: 'View',
      items:
        'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments',
    },
    insert: {
      title: 'Insert',
      items:
        'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime | eqneditor',
    },
    format: {
      title: 'Format',
      items:
        'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat',
    },
    tools: {
      title: 'Tools',
      items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount',
    },
    table: {
      title: 'Table',
      items:
        'inserttable | cell row column | advtablesort | tableprops deletetable',
    },
  },

  importcss_append: true,
  autosave_ask_before_unload: true,
  promotion: false,
  branding: false,
  elementpath: false,
  advlist_bullet_styles: 'default,circle,disc,square',
  htmlAllowedTags: ['.*'],
  htmlAllowedAttrs: ['.*'],
  plugins: [
    'eqneditor',
    'image',
    'media',
    'table',
    'Tools',
    'charmap',
    'code',
    'anchor',
    'link',
    'autosave',
    'directionality',
    'emoticons',
    'fullscreen',
    'importcss',
    'insertdatetime',
    'lists',
    'nonbreaking',
    'pagebreak',
    'preview',
    'quickbars',
    'save',
    'searchreplace',
    'wordcount',
    'visualblocks',
    'visualchars',
  ],
  toolbar:
    'eqneditor undo redo styleselect bold italic  alignleft aligncenter alignright alignjustify  outdent indent numlist bullist  preview searchreplace code anchor link restoredraft  charmap ltr rtl emoticons fullscreen  insertdatetime pagebreak quickimage save wordcount visualblocks visualchars tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
  eqneditor_server: 'fxtex.codecogs.com',
  eqneditor_licence: environment.codecogsLicenceKey || '',
  eqneditor_design: {
    colour: '#1a73e8',
  },
  //  tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry
  // table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol |
};
